import { Navigate } from "react-router-dom";

// 保留旧书签入口，统一跳过类别选择并进入活动列表。
export default function DonationSelect() {
  return <Navigate to="/donation" replace />;
}
